import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import SectionHeader from "../sectionHeader";
import SectionSubHeader from "../sectionSubHeader";
import StoriesCard from "../StoriesCard";
import Slider from "react-slick";
import { ArrowLeft, ArrowRight } from "../../assets/svg";

const OurSucessStories = () => {
  const sliderRef = useRef(null);

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 991, // Below 991px
        settings: {
          slidesToShow: 1, // Show 2 slides
        },
      },
      {
        breakpoint: 540, // Below 540px
        settings: {
          slidesToShow: 1, // Show 1 slide
        },
      },
    ],
  };

  return (
    <div className="volto-section our-sucess-stories pb-5">
      <Container>
        <Row>
          <Col lg={7} xs={11}>
            <SectionHeader
              mainText1="Passion, Innovation,"
              mainText2="and Growth drive"
            />
            <SectionSubHeader headerText="Life at VOLTO" />
          </Col>
        </Row>
        <Row>
          <div className="life-at-volto-container">
            <Col lg={7} xs={12}>
              <Slider {...settings} className="mt-lg-5 mt-4" ref={sliderRef}>
                <div>
                  <StoriesCard
                    empName={"Brendan Opoku"}
                    story={
                      "Working for Volto during one of the most trying times in our country has been enjoyable. They make sure we have an easy work experience. Volto has made sure that we are compliant and paid on a timely manner. I’m appreciative of the opportunity that I have to work for Volto."
                    }
                  />
                </div>
                <div>
                  <StoriesCard
                    empName={"Tom M"}
                    story={
                      "Volto is focused on what their client's needs really are to make sure the employee and the roll are a perfect fit. Their staff have always been professional, helpful, and friendly. They made the entire hiring process with a disorganized client simple and seamless."
                    }
                  />
                </div>
                <div>
                  <StoriesCard
                    empName={"Deborah Brown"}
                    story={
                      "Volto is an amazing company to work for and I’ve worked for Volto for almost a year and have no complaints. Staff is friendly, supportive and easy to communicate with. I would definitely recommend this company."
                    }
                  />
                </div>
                <div>
                  <StoriesCard
                    empName={"Subodh Singh"}
                    story={
                      "Experience in Working with Volto: I couldn't have asked for a better company to work for. All my inquiries be it related to payroll, schedule are responded timely. They connected me to an excellent client that offer flexible schedule and the best part is neither Volto or the client micro manages their employees, which makes the work environment extremely pleasant. I highly recommend Volto to all applicants that are seeking employment."
                    }
                  />
                </div>
                <div>
                  <StoriesCard
                    empName={`Ryan O'Neill`}
                    story={
                      "My time with Volto Consulting has been extremely satisfying. To begin with, I was recruited at the beginning of the Covid-19 lock down. Volto was able to take on a difficult task of on boarding me with TCS. This was a new work landscape that was managed with new and developing protocols in a professional manner. I am thankful for the effort that was made to get me started with my employer in a timely manner during this difficult time. The team at Volto has kept in regular contact with me to make sure I was updated with any information that regarded me. The method of online payroll through the Gusto portal has been an easy and excellent process. In summary, I highly recommend and endorse working with this company and would do it again if the opportunity presented itself again."
                    }
                  />
                </div>
              </Slider>
            </Col>
            <Col lg={5} xs={12}>
              <div className="custom-arrow new">
                <span onClick={() => sliderRef.current.slickPrev()}>
                  <ArrowLeft />
                </span>
                <span onClick={() => sliderRef.current.slickNext()}>
                  <ArrowRight />
                </span>
              </div>
            </Col>
          </div>
        </Row>
      </Container>
      <img
        className="life-at-volto-bg"
        src="/images/life-at-volto.webp"
        alt="life-at-volto"
      />
    </div>
  );
};

export default OurSucessStories;
